module.exports = __webpack_public_path__ + "img/slide_4.aaf34b5e.jpg";